import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { AxiosResponse } from 'axios'
import { BankingDepositCreateValidationSchema } from '../schemas/create.schema'

type UseCreateBankingDepositProps = {
  companyId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCreateBankingDeposit = ({
  onSuccess,
  onError,
}: UseCreateBankingDepositProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createBankingDeposit'],
    mutationFn: async (form: BankingDepositCreateValidationSchema) => {
      const payload = {
        deposit: {
          requested_total: form.requested_total && unFormatCurrency(form.requested_total),
          payment_method_id: form.payment_method?.id,
        }
      }

      return privateAxios.post(`/banking/deposits`, payload);
    },
    onSuccess,
    onError,
  });
}
